<template>
	<div
		class="g-block-video-header"
		:class="{
			'g-block-video-header--edit': editable,
			'is-active': editable && active,
			'g-block-video-header--h5': h5,
		}"
		@click="onWrapClick"
	>
		<HeaderVideoPreview
			v-if="videoItem"
			:item="videoItem"
			:title="videoData.title"
			layout="card"
			:h5="h5"
			:id-key="idKey"
		/>
	</div>
</template>

<script>
	import HeaderVideoPreview from '../../../components/HeaderVideoPreview.vue';
	import { getHeaderVideoItem } from '../../../utils/localVideo.js';
	import { normalizeVideoHeaderData } from '../../../utils/videoHeader.js';

	export default {
		name: 'GBlockVideoHeader',
		components: { HeaderVideoPreview },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
		},
		emits: ['select'],
		computed: {
			videoData() {
				return normalizeVideoHeaderData(this.data);
			},
			videoItem() {
				return getHeaderVideoItem(this.videoData);
			},
		},
		methods: {
			onWrapClick() {
				if (this.editable) {
					this.$emit('select');
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-video-header {
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}
</style>
